module.exports = __webpack_public_path__ + "static/trees-6d971f7810bb0a12bab63ef33c7c1793.svg";